// src/pages/Dashboard.jsx
import { useAuth } from '../context/AuthContext';
import { FireLoader } from '../components/Loader';
import AdminDashboard from './dashboards/AdminDashboard';
import TeacherDashboard from './dashboards/TeacherDashboard';
import StudentDashboard from './dashboards/StudentDashboard';
import ParentDashboard from './dashboards/ParentDashboard';

export default function Dashboard() {
  const { user, loading } = useAuth();

  if (loading) return <FireLoader fullScreen={true} size="lg" text="Loading..." />;

  const role = user?.role;

  if (role === 'admin' || role === 'super_admin') return <AdminDashboard />;
  if (role === 'teacher') return <TeacherDashboard />;
  if (role === 'student') return <StudentDashboard />;
  if (role === 'parent') return <ParentDashboard />;

  return (
    <div className="text-center py-12">
      <p className="text-primary-500">Unknown role – no dashboard available.</p>
    </div>
  );
}